import { Component } from '@angular/core';
import { ROUTE_CONSTANTS } from '@app/core/constants/route.constant';

@Component({
    selector: 'app-forbidden',
    templateUrl: './forbidden.component.html',
    styleUrl: './forbidden.component.scss',
    standalone: false,
})
export class ForbiddenComponent {
    ROUTE_CONSTANTS = ROUTE_CONSTANTS;
}
